// extracted by mini-css-extract-plugin
export default {"card":"TemplateCard-module__card__-4OpK","active":"TemplateCard-module__active__tLYi6","content":"TemplateCard-module__content__iuGmI"};